import { Component, OnInit } from '@angular/core';
import { IonSlides, NavController,Platform, ModalController } from '@ionic/angular';
import { ServiceService } from 'src/app/services/service/service.service';
import { Router } from '@angular/router';
import { BannerService } from 'src/app/services/banner/banner.service';
import { CouponService } from 'src/app/services/coupon/coupon.service';
import { ToastComponent } from 'src/app/shared/toast/toast.component';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { SetLocationComponent } from 'src/app/shared/set-location/set-location.component';
import { AreaService } from 'src/app/services/Area/area.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { UserService } from 'src/app/services/user/user.service';
import { JobService } from 'src/app/services/jobs/job.service';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { google } from 'google-maps';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss']
})
export class HomePage implements OnInit {
selected = 'Sydney';
place:any;
userData:any;
allServices:any;
allBanners:any;
allOffers:any;
subscription:any;
counter:any = 0;
showPop:boolean=false;
totalPending:any=0;
private geoCoder ;
	slidesDidLoad(slides: IonSlides) {
  slides.startAutoplay();
}	
optionsForSlide:{
  speed:10,
  sliderPerView:2
}

constructor(

  private servicesService:ServiceService,
  private navCtrl:NavController,
  private locationAccuracy: LocationAccuracy,
    private openNativeSettings: OpenNativeSettings,
    private alert:AlertComponent,
  private r:Router,
  private toast:ToastComponent,
  private platform: Platform,
  private modal:ModalController,
  private couponService:CouponService,
  private bannerService:BannerService,
  public loader:LoaderService,
  private callNumber: CallNumber,
  private areaServic:AreaService,
  private paymentService:PaymentService,
  private transactionService:TransactionService,
  private userService:UserService,
  private JobService:JobService
  ){
   
  }



    slideOpts = {
      slidesPerView: 6,
    };
    ngOnInit(){
      console.log('Screen Width is: ',this.platform.width());
      if(this.platform.width() > 1200) {
        this.slideOpts.slidesPerView = 5;
      }
   
      // On a desktop, and is wider than 768px
      else if(this.platform.width() > 768) {
        this.slideOpts.slidesPerView = 2;
      }
   
      // On a desktop, and is wider than 400px
      else if(this.platform.width() > 400) {
        this.slideOpts.slidesPerView = 2;
      }
   
      // On a desktop, and is wider than 319px
      else if(this.platform.width() > 319) {
        this.slideOpts.slidesPerView = 1;
      }
      setTimeout(() => {
        // this.getAddress();
        // this.locationaccuracy();
        this.data(null);
      }, 3000);
        // this.getAddress();
     
    }
    // setTimeout(() => {
    //   this.getAddress();
    //   this.locationaccuracy();
    //   this.data(null);
    // }, 3000);
    //   // this.getAddress();
   

    callNumberfun(){
      this.callNumber.callNumber("+916306023551", true)
  .then(res => console.log('Launched dialer!', res))
  .catch(err => console.log('Error launching dialer', err));
    }
  




  data(event){
    this.checkLocation();

    this.totalPending=0;
    this.allBanners = JSON.parse(localStorage.getItem('Banners'));
    this.allServices = JSON.parse(localStorage.getItem("homeData"));  
    this.allOffers = JSON.parse(localStorage.getItem("Offers"));  
    let locationId = localStorage.getItem('locationId');
    console.log(this.allServices);
    this.userData = JSON.parse(localStorage.getItem('userProfile'));
    // if(this.userData){
    //   setTimeout(() => {
  
    //   this.userService.getUserDetails(this.userData.id).then((res:any)=>{
  
    //       if(res.duePayment.amount || res.pendingService && res.pendingService.amount){
    //         this.showPop=true;
    //         if(res.duePayment.amount){
    //           this.totalPending +=parseInt(res.duePayment.amount)
    //         }
    //         if(res.pendingService && res.pendingService.amount){
    //           this.totalPending +=parseInt(res.pendingService.amount)
    //         }
    //       }else{
    //         this.showPop=false;
  
    //       }
    //   })
    // }, 1000);
    // }

    this.place = localStorage.getItem('location');
  
    this.bannerService.getAllBanners().then((res)=>{
      console.log(res);
      if(this.allBanners){
        if(JSON.stringify(this.allBanners) !== JSON.stringify(res) ){
          localStorage.setItem("Banners",JSON.stringify(res))
        }
      }else{
        this.allBanners = res;
        localStorage.setItem("Banners",JSON.stringify(res))
      }
      
    })
    this.servicesService.getAllServices("0",locationId).then((res)=>{
      console.log(res);
      if(this.allServices){
        if(JSON.stringify(this.allServices) !== JSON.stringify(res) ){
          localStorage.setItem("homeData",JSON.stringify(res))
          this.allServices = res;
        
        }
      }else{
        this.allServices = res;
        localStorage.setItem("homeData",JSON.stringify(res))
      }
      if(event !== null){
        event.target.complete();
      }
    })
    this.couponService.getAllCouponssForHome("Offer").then((res)=>{
      console.log(res);
      if(this.allOffers){
        if(JSON.stringify(this.allOffers) !== JSON.stringify(res) ){
          localStorage.setItem("Offers",JSON.stringify(res))
        }
      }else{
        this.allOffers = res;
        localStorage.setItem("Offers",JSON.stringify(res))
      }
    })
  }

  
  ionViewDidLeave(){
    this.areaServic.showHome=false;
    console.log("asdasd")
  }

  async ionViewDidEnter(){
    this.areaServic.showHome=true
    this.showPop=false;

    if(localStorage.getItem("locationId")){
    this.data(null);
    }else{
      const modal = await this.modal.create({
        component: SetLocationComponent,
        cssClass: 'my-custom-class',
        swipeToClose: true,
      });
      await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data);

      this.data(null);
    
    }
    this.loader.page = "home";
    this.subscription = this.platform.backButton.subscribe(()=>{
      if (this.counter == 0) {
        this.counter++;
        this.toast.presentToastError('Press again to exit.');
        setTimeout(() => { this.counter = 0 }, 3000)
      } else {
        navigator['app'].exitApp();
      }
  });
  }

  checkLocation(){
    if(localStorage.getItem('location')){
      this.place = localStorage.getItem('location');
    }
  }

  ionViewWillLeave(){
    console.log(document.getElementById("mainbox1234")),
    document.getElementById("mainbox1234").classList.add("size")
    this.subscription.unsubscribe();
  }
  ionViewWillEnter(){
    
  console.log(document.getElementById("mainbox1234")),
  document.getElementById("mainbox1234").classList.remove("size")
  }

  dorefresh(event){
      this.data(event);
  }


searchpagegoing(){
   this.navCtrl.navigateForward("/search-pagedesign");
}
nextPage(subservice){
  console.log(subservice);
  if(subservice.subServices && subservice.subServices.length > 0){
    console.log("nextpage",this.place);
    this.navCtrl.navigateForward("/subservice/"+subservice.service_Name.replaceAll(/ /g, '_'));
  }else{
    let data = {
      "serviceId":subservice.id,
      "service":subservice,
      "city":this.place,
      "locationId":localStorage.getItem("locationId"),
      "serviceName":subservice.service_Name,
      "measureableUnit":subservice.measureableUnitId
    }
    localStorage.setItem('JobData',JSON.stringify(data));
    if(subservice.measureableUnitId && subservice.measureableUnitId[0] && subservice.measureableUnitId[0] !== null ){

      this.navCtrl.navigateForward('/choose-functionality');
    }else{
      this.navCtrl.navigateForward('/service-detail');
    }
  }
}
// locationaccuracy(){
//   this.locationAccuracy.canRequest().then((canRequest: boolean) => {
//     console.log("can request",canRequest);
//     if(canRequest) {
//       // the accuracy option will be ignored by iOS
//       this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
//         () => {
//           console.log('Request successful');
//             this.getAddress();
//         },
//         error => {
//           this.alert.presentAlertConfirm("Some of the features of the app require your location to function optimally.","cancel","settings").then((res)=>{
//             if(res['role'] == 'cancel' ){
//               console.log("cancel");
//             }else{
//               this.openNativeSettings.open("locations").then((res)=>{
//                 console.log("res",res);
                
//                 setTimeout(() => {
//                     this.getAddress();
//                   }, 7000);
    
//               }).catch((err)=>{
//                 console.log("err",err);
//               })
//             }
//             });
//           console.log('Error requesting location permissions', error);
//       }
//       );
//     }else{
//       this.getAddress();

//     }
//   });
// }


//   getAddress() {
//     if ('geolocation' in navigator) {
//       console.log("in navigator");
//       this.geoCoder = new google.maps.Geocoder;
//       navigator.geolocation.getCurrentPosition((position) => {
//         console.log("in navigator Position",position);
//         this.geoCoder.geocode({ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } }, (results, status) => {
//           console.log("in geocode Position",results,status);
//           if (status === 'OK') {
//         // if (results[0]) {
          
//         //   let plac = results[0].formatted_address.split(',');
//         //   console.log(plac[plac.length - 3]);
//         //   if(this.place){
//         //     if(plac[plac.length - 3].toString().trim() !== this.place.toString().trim()){
//         //       localStorage.setItem('location',plac[plac.length - 3]);
//         //     }
//         //   }else{
//         //     this.place = plac[plac.length - 3];
//         //     localStorage.setItem('location',plac[plac.length - 3]);
//         //   }
//         // } else {
//         //   window.alert('No results found');
//         // }
//         } else {
//         window.alert('Geocoder failed due to: ' + status);
//         }
//       });
//     });
//   }
//   }


  offernext(offer){
    console.log(offer);
    let data = {
      "serviceId":offer.services.id,
      "service":offer.services,
      "city":this.place,
      "coupon":offer,
      "couponId":offer.id,
      "serviceName":offer.services.service_Name,
      "measureableUnit":offer.services.measureableUnitId
    }
    localStorage.setItem('JobData',JSON.stringify(data));
    if(offer.services.measureableUnitId[0] !== null){
      this.navCtrl.navigateForward('/choose-functionality');
    }else{
      this.navCtrl.navigateForward('/service-detail');
    }
  }


  async changePlace(){
    console.log("location");
    const modal = await this.modal.create({
      component: SetLocationComponent,
      cssClass: 'my-custom-class',
      swipeToClose: true,
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    this.data(null);
    // this.navCtrl.navigateRoot('/choose-location');
  }

 
  about(){
    this.navCtrl.navigateForward('/app/about');
    this.loader.page = "about";
  }
  contact(){
    this.navCtrl.navigateForward('/app/contact');
    this.loader.page = "contact";
  }

  payWithRazor() {
    let self=this
    // self.loader.showLoading();
    let userdata = JSON.parse(localStorage.getItem('userProfile'));
    const options: any = {
      key:"rzp_test_RUV8qOpX3MjO3i",
            name:"Fixit Now Service",
            description:"Due Payment",
            amount:self.totalPending*100,
            image:  '/assets/img/icon.png',
            currency:'INR',
            prefill:{
                      name:userdata.fullName,
                      email:userdata.email
                    },
      // order_id: id, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        "UserId":userdata.id
      },
      theme: {
        color:'#f68517'
      }
    };

    options.handler = ((response, error) => {
      options.response = response;
      console.log(response);
      self.addPayment(response)

      console.log(options);
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
    self.loader.hideLoading();

      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
      // alert('trasaction cancelled')
    });
    const rzp = new this.transactionService.nativeWindow.Razorpay(options);
    setTimeout(() => {
      rzp.open();
    }, 100);


  }

  addPayment(stripeData){
    let userdata = JSON.parse(localStorage.getItem('userProfile'));

    let data ={ 
      "jobId":userdata.id,
      "Amount":this.totalPending,
      "vendorStatus":true,
      "userStatus":true,
      "vendorType":"",
      "userType":"RazorPay",
      "status":true
  }
  this.paymentService.addPayment(data).then((res:any)=>{
    console.log(res);
    let transactionDetails = {
      "paymentId":res.id,
      "usertype":"user",
      "transactionId":stripeData,
      "amount":userdata.duePayment.amount,
      "transactiontype":"RazorPay",
      "userId":userdata.id,
      "status":true,
      "transactionAssets":stripeData
    };
    this.transactionService.addTransaction(transactionDetails).then((res)=>{
      this.userService.editUser({"duePayment":"","pendingService":""},userdata.id).then((res:any)=>{
        if(this.userData.pendingService && this.userData.pendingService.jobId){
          this.JobService.editJob({"pendingPayment":""},this.userData.pendingService.jobId)
        }
        this.showPop=false;
        this.navCtrl.navigateForward(('/Home'))
      })
     
    })
  
  })
}



}
